import React, { useEffect, useState, useRef } from "react";
import "./index.scss";
import { Button, Grid, TextField } from "@mui/material";
import Select from "react-select";
import { invokeApi } from "../../utils/http-service";
import moment from "moment";
import { toast } from "react-toastify";
import Autocomplete from "@mui/material/Autocomplete";
import axios from "axios";
import ClearIcon from "@mui/icons-material/Clear";

import { checkValidStoreCombination } from "../../utils";

import { HTTP_METHODS } from "../../../common-utilities/utils/http-service";
import { HOSTNAME } from "../../../common-utilities/utils/end-points";
import { REST_URLS } from "../../../common-utilities/utils/end-points/subway-subs";
import { getLabelsAndValuesForSelect } from "../../../common-utilities/utils";
import StickyHeaderCon from "../../../common-utilities/core/sticky-header-table";

const StartFile = () => {
  const [storeOptions, setStoreOptions] = useState([]);
  const [storeInput, setStoreInput] = useState("");
  const [leaseDetails, setLeaseDetails] = useState({ store: null });
  const [leaseIdList, setLeaseIdList] = useState([]);
  const [satteliteList, setSatteliteList] = useState([]);
  const [sequenceList, setSequenceList] = useState([]);
  const [isCreate, setIsCreate] = useState(false);

  const previousController = useRef();

  const clearData = () => {
    setLeaseDetails({});
    setStoreInput("");
    setStoreOptions([]);
    setLeaseIdList([]);
    setSatteliteList([]);
    setSequenceList([]);
    if (isCreate) {
      setIsCreate(false);
    }
  };

  const dateFun = (val) => {
    if (val) {
      if (new Date(val) == "Invalid Date") {
        let split = val?.split("-");
        let d =
          split.length > 0 ? split[2] + "/" + split[1] + "/" + split[0] : null;
        if (d) {
          return moment(d).format("yyyy-MM-DD");
        } else {
          return "";
        }
      } else {
        return moment(val).format("yyyy-MM-DD");
      }
    }
  };

  const stateUpdate = (updatedValues) => {
    setLeaseDetails((prevState) => {
      return { ...prevState, ...updatedValues };
    });
  };

  const apply = (id) => {
    if (Number.isInteger(parseInt(id))) {
      invokeApi(
        HTTP_METHODS.GET,
        HOSTNAME + REST_URLS.GET_LEASE + id + "/" + storeInput
      ).then((res) => {
        if (res.code === 404) {
          toast.info("No Lease is Avaialble for the selected Store", {
            autoClose: 2000,
          });
        } else {
          let obj = {};
          obj["franchiseSold"] = dateFun(res?.storeLease?.dates?.franchiseSold);
          obj["requested"] = dateFun(
            res?.storeLease?.notificationLetters?.requested
          );
          obj["sent"] = dateFun(res?.storeLease?.notificationLetters?.sent);
          obj["fileSiteReview"] = dateFun(res?.storeLease?.fileSiteReview);
          obj["excessiveLiabilityApproval"] = dateFun(
            res?.storeLease?.liabilityInfo?.excessiveLiabilityApproval
          );
          obj["negotiation"] = dateFun(res?.storeLease?.dates?.negotiation);
          obj["leaseRep"] = res?.storeLease?.representatives?.leaseRep;
          obj["renegotiationRep"] =
            res?.storeLease?.representatives?.renegotiationRep;
          obj["settlementRep"] =
            res?.storeLease?.representatives?.settlementRep;
          obj["leaseRenegotiatedBy"] =
            res?.storeLease?.representatives?.leaseRenegotiatedBy;
          obj["status"] = res?.storeLease?.status;
          obj["type"] = res?.storeLease?.type;
          obj["leaseReceived"] = dateFun(res?.storeLease?.dates?.leaseReceived);
          obj["intentToSubLease"] = dateFun(
            res?.storeLease?.dates?.intentToSubLease
          );
          obj["checkForTwoMonthsRent"] = dateFun(
            res?.storeLease?.dates?.checkForTwoMonthsRent
          );
          obj["completedSiteEvaluation"] = dateFun(
            res?.storeLease?.dates?.completedSiteEvaluation
          );
          obj["specAuthorization"] = dateFun(
            res?.storeLease?.dates?.specAuthorization
          );
          stateUpdate(obj);
        }
      });
    }
  };

  const handleChange = (event) => {
    let key = event.target.name;
    let value = event.target.value;
    let tempState = { ...leaseDetails };
    tempState[key] = value;
    setLeaseDetails(tempState);
  };

  const onInputChange = (event, value, reason) => {
    setLeaseDetails((prevDetails) => ({
      ...prevDetails,
      satelliteNo: null,
      sequenceNo: null,
      leaseId: null,
    }));
    setSatteliteList([]);
    setSequenceList([]);
    setLeaseIdList([]);
    if (value?.trim()) {
      getData(value);
    } else {
      clearData();
    }
    setStoreInput(value ? value : "");
  };

  const selectHandle = (name, value, fieldsToClear = {}) => {
    const clearedData = fieldsToClear ? fieldsToClear : {};
    let tempState = { ...leaseDetails, ...clearedData };
    tempState[name] = value;
    setLeaseDetails(tempState);
  };

  const getData = (searchTerm) => {
    if (previousController.current) {
      previousController.current.abort();
    }
    const controller = new AbortController();
    const signal = controller.signal;
    previousController.current = controller;
    axios({
      method: HTTP_METHODS.GET,
      url: HOSTNAME + REST_URLS.STORE_SEARCH + searchTerm,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      signal: signal,
    }).then((response) => {
      const updatedOptions = response.data.map((p) => {
        return { title: p.storeNo, id: p.storeNo, satellite: p.satelliteNum };
      });
      setStoreOptions(updatedOptions);
    });
  };

  const columns = [
    { id: "check", label: "Check #" },
    { id: "amount", label: "Amount" },
    { id: "receiveDate", label: "Receive Date" },
  ];

  const listingLeaseHandler = (id, satelliteNo, sequenceNo) => {
    const invalidStoreCombination = !checkValidStoreCombination(
      id,
      satelliteNo,
      sequenceNo
    );

    if (invalidStoreCombination) {
      return;
    }

    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.LIST_LEASES}${id}`,
      null,
      {
        satelliteNo,
        sequenceNo,
      }
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message, { autoClose: 2000 });
        } else {
          const result = res.map((ele) => ({ label: ele.id, value: ele.id }));
          setLeaseIdList(result);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllSequenceNumberAndSatelliteNumbersForStoreNumber = (id) => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.GET_ALL_SEQUENCE_NUMBER_AND_SATELLITE_NUMBER_FOR_STORE_NUMBER}${id}`
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message, { autoClose: 2000 });
        } else {
          const { satelliteNumbers, sequenceNumbers } = res;
          const satelliteLabelAndValuesForSelect = getLabelsAndValuesForSelect(
            satelliteNumbers,
            satelliteNumbers
          );

          const sequenceNumberLabelAndValuesForSelect =
            getLabelsAndValuesForSelect(sequenceNumbers, sequenceNumbers);
          setSatteliteList(satelliteLabelAndValuesForSelect);
          setSequenceList(sequenceNumberLabelAndValuesForSelect);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div className="lease">
      <Grid container md={12} sx={{ mt: 5, mb: 0 }}>
        <Grid item md={2} xs={4}>
          <Autocomplete
            id="free-solo-demo"
            freeSolo
            getOptionLabel={(option) => {
              return option.title ? option.title.toString() : "";
            }}
            clearIcon={
              <ClearIcon
                font
                onClick={() => {
                  clearData();
                }}
              />
            }
            options={storeOptions}
            renderInput={(params) => (
              <TextField {...params} className="sel-item" label="Store" />
            )}
            inputValue={storeInput}
            onInputChange={onInputChange}
            onChange={(e, val) => {
              if (val) {
                getAllSequenceNumberAndSatelliteNumbersForStoreNumber(val?.id);
              }
            }}
          />
        </Grid>
        <Grid item md={2} xs={4}>
          <Select
            classNamePrefix="custom_select"
            placeholder="Satellite"
            className="sel-item"
            options={satteliteList}
            value={
              ![undefined, null].includes(leaseDetails.satelliteNo)
                ? satteliteList.find((i) => i.value == leaseDetails.satelliteNo)
                : ""
            }
            onChange={(val) => {
              selectHandle("satelliteNo", val?.value, { leaseId: null });
              listingLeaseHandler(
                storeInput,
                val?.value,
                leaseDetails.sequenceNo
              );
            }}
          />
        </Grid>
        <Grid item md={2} xs={4}>
          <Select
            classNamePrefix="custom_select"
            placeholder="Sequence Number"
            className="sel-item"
            options={sequenceList}
            value={
              ![undefined, null].includes(leaseDetails.sequenceNo)
                ? sequenceList.find((i) => i.value == leaseDetails.sequenceNo)
                : ""
            }
            onChange={(val) => {
              selectHandle("sequenceNo", val?.value, { leaseId: null });
              listingLeaseHandler(
                storeInput,
                leaseDetails.satelliteNo,
                val?.value
              );
            }}
          />
        </Grid>
        <Grid item md={4}>
          <Select
            classNamePrefix="custom_select"
            placeholder="lease Id"
            className="sel-item"
            options={leaseIdList}
            value={
              ![undefined, null].includes(leaseDetails.leaseId)
                ? leaseIdList.find((i) => i.value == leaseDetails.leaseId)
                : ""
            }
            onChange={(val) => {
              setLeaseDetails((prevDetails) => ({
                ...prevDetails,
                leaseId: val?.value,
              }));
              apply(val?.value);
            }}
          />
        </Grid>
        <Grid item md={2} xs={6} style={{ height: "35px" }}>
          <span
            style={{
              display: "flex",
              padding: "5px",
              borderRadius: "5px",
              float: "right",
              marginTop: "-5px",
            }}
          >
            <Button
              size="small"
              variant="outlined"
              sx={{ mr: 2 }}
              onClick={clearData}
            >
              Reset
            </Button>
            <Button
              size="small"
              variant="contained"
              onClick={() => {
                //  update();
              }}
              disabled
            >
              Save
            </Button>
          </span>
        </Grid>
      </Grid>

      <Grid container md={12} xs={12}>
        <Grid item md={6}>
          <div className="title">Dates</div>
          <div className="g-r-2" sx={{ mt: 1 }}>
            <div>
              <p className="input-title-paragrah">Fran. Sold</p>
              <TextField
                fullWidth
                className="sel-item"
                type="date"
                value={dateFun(leaseDetails.franchiseSold) || ""}
                name="franchiseSold"
                onChange={handleChange}
                disabled
              />
            </div>
            <div>
              <p className="input-title-paragrah">Negotiation</p>
              <TextField
                fullWidth
                className="sel-item"
                type="date"
                value={dateFun(leaseDetails.negotiation) || ""}
                name="negotiation"
                onChange={handleChange}
                disabled
              />
            </div>
          </div>
          <div className="g-r-2" sx={{ mt: 1 }}>
            <div>
              <p className="input-title-paragrah">Notif. Lett. Req</p>
              <TextField
                fullWidth
                className="sel-item"
                type="date"
                value={dateFun(leaseDetails.requested) || ""}
                name="requested"
                onChange={handleChange}
                disabled
              />
            </div>
            <div>
              <p className="input-title-paragrah">Notif. Lett. Sent</p>
              <TextField
                fullWidth
                className="sel-item"
                type="date"
                value={dateFun(leaseDetails.sent) || ""}
                name="sent"
                onChange={handleChange}
                disabled
              />
            </div>
          </div>
          <div className="g-r-2" sx={{ mt: 1 }}>
            <div>
              <p className="input-title-paragrah">File Site Review</p>
              <TextField
                fullWidth
                className="sel-item"
                type="date"
                value={dateFun(leaseDetails.fileSiteReview) || ""}
                name="fileSiteReview"
                onChange={handleChange}
                disabled
              />
            </div>
            <div>
              <p className="input-title-paragrah">Record Fee Rec'd</p>
              <TextField
                fullWidth
                className="sel-item"
                type="date"
                // value={leaseDetails.sequenceNum || ""}
                // name="sequence"
                // onChange={handleChange}
                disabled
              />
            </div>
          </div>
          <div className="g-r-2" sx={{ mt: 1 }}>
            <div>
              <p className="input-title-paragrah">
                Excessive Liability Approval
              </p>
              <TextField
                fullWidth
                className="sel-item"
                type="date"
                value={dateFun(leaseDetails.excessiveLiabilityApproval) || ""}
                name="excessiveLiabilityApproval"
                onChange={handleChange}
                disabled
              />
            </div>
          </div>
          <Grid sx={{ mt: 2, mr: 2 }}>
            <div className="title">Sublease Deposits</div>
            <StickyHeaderCon
              columnsList={columns}
              containerHeight="table-con"
            />
          </Grid>
        </Grid>
        <Grid item md={6}>
          <Grid sx={{ display: "grid", gridGap: "10px" }}>
            <div className="title">Association</div>
            <div className="g-r-2">
              {/* <Select classNamePrefix="custom_select" placeholder="Dev. Agent" className="sel-item" /> */}
              <TextField
                label="Dev. Agent"
                fullWidth
                variant="outlined"
                className="sel-item"
                value={leaseDetails.leaseRenegotiatedBy || ""}
                name="leaseRenegotiatedBy"
                onChange={handleChange}
                disabled
              />
              <TextField
                label="Lease Rep."
                fullWidth
                variant="outlined"
                className="sel-item"
                value={leaseDetails.leaseRep || ""}
                name="leaseRep"
                onChange={handleChange}
                disabled
              />
            </div>
            <div className="g-r-2">
              <TextField
                label="Reneg. Rep."
                fullWidth
                variant="outlined"
                className="sel-item"
                value={leaseDetails.renegotiationRep || ""}
                name="renegotiationRep"
                onChange={handleChange}
                disabled
              />
              <TextField
                label="Settl. Rep."
                fullWidth
                variant="outlined"
                className="sel-item"
                value={leaseDetails.settlementRep || ""}
                name="settlementRep"
                onChange={handleChange}
                disabled
              />
            </div>
          </Grid>

          <Grid sx={{ mt: 3 }}>
            <div className="title">Types</div>
            <div className="g-r-2">
              {/* <Select placeholder="Lease" className="sel-item" classNamePrefix="custom_select" />
              <Select placeholder="Status" className="sel-item" classNamePrefix="custom_select" /> */}
              <TextField
                label="Status"
                fullWidth
                variant="outlined"
                className="sel-item"
                value={leaseDetails.status || ""}
                name="status"
                onChange={handleChange}
                disabled
              />
              <TextField
                label="Lease"
                fullWidth
                variant="outlined"
                className="sel-item"
                value={leaseDetails.type || ""}
                name="type"
                onChange={handleChange}
                disabled
              />
            </div>
          </Grid>
          <Grid item md={12} sx={{ mt: 3 }}>
            <div className="title">Document Dates</div>
            <Grid className="g-r-2" sx={{ mt: 1 }}>
              <div>
                <p className="input-title-paragrah">Lease Received</p>
                <TextField
                  fullWidth
                  className="sel-item"
                  type="date"
                  value={dateFun(leaseDetails.leaseReceived) || ""}
                  name="leaseReceived"
                  onChange={handleChange}
                  disabled
                />
              </div>
              <div>
                <p className="input-title-paragrah">Complete Site Evaluation</p>
                <TextField
                  fullWidth
                  className="sel-item"
                  type="date"
                  value={dateFun(leaseDetails.completedSiteEvaluation) || ""}
                  name="completedSiteEvaluation"
                  onChange={handleChange}
                  disabled
                />
              </div>
            </Grid>
            <Grid className="g-r-2" sx={{ mt: 1 }}>
              <div>
                <p className="input-title-paragrah">Intent to Sublease</p>
                <TextField
                  fullWidth
                  className="sel-item"
                  type="date"
                  value={dateFun(leaseDetails.intentToSubLease) || ""}
                  name="intentToSubLease"
                  onChange={handleChange}
                  disabled
                />
              </div>
              <div>
                <p className="input-title-paragrah">Spec Authorization</p>
                <TextField
                  fullWidth
                  className="sel-item"
                  type="date"
                  value={dateFun(leaseDetails.specAuthorization) || ""}
                  name="specAuthorization"
                  onChange={handleChange}
                  disabled
                />
              </div>
            </Grid>
            <Grid className="g-r-2" sx={{ mt: 1 }}>
              <div>
                <p className="input-title-paragrah">Check For 2 Months Rent</p>
                <TextField
                  fullWidth
                  className="sel-item"
                  type="date"
                  value={dateFun(leaseDetails.checkForTwoMonthsRent) || ""}
                  name="checkForTwoMonthsRent"
                  onChange={handleChange}
                  disabled
                />
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default StartFile;
